export function checkButtonsVisibility(iconsContainer) {
    const result = {
        leftPaddleEnabled: false,
        rightPaddleEnabled: false,
        dropdownEnabled: false
    };
    let iconsContainerLeftSide = iconsContainer.getBoundingClientRect().left;
    let iconsContainerRightSide = iconsContainer.getBoundingClientRect().right;

    if (iconsContainer.childElementCount > 0) {
        //leftPaddle
        for (let i = 0; i < iconsContainer.childElementCount; i++) {
            //Se l'icona i-esima non e' visibile, si passa all'icona successiva
            if (window.getComputedStyle(iconsContainer.children[i]).display === "none") {
                //Se arriviamo all'ultima icona e anch'essa non e' visibile
                //il leftPaddle diventa invisibile
                if (i === iconsContainer.childElementCount - 1) {
                    this.leftPaddle.classList.add("d-none");
                    result.leftPaddleEnabled = false;
                    break;
                }
                continue;
            } else {
                //L'icona e' visibile
                let iconLeftSide = iconsContainer.children[i].getBoundingClientRect().left;
                //Se il suo lato sinistro e' minore del lato sinistro dell'iconsContainer, il leftPaddle diventa visibile
                if (iconsContainer.children[i].getBoundingClientRect().left < iconsContainer.getBoundingClientRect().left) {
                    result.leftPaddleEnabled = true;
                    break;
                } else if (iconLeftSide >= iconsContainerLeftSide) {
                    result.leftPaddleEnabled = false;
                    break;
                }
            }
        }

        //rightPaddle
        //Per il rightPaddle ragioniamo a ritroso, perche' il rightPaddle dipende dalla visibilita' delle ultime icone (quindi guardandole da destra a sinistra)
        for (let i = 0; i < iconsContainer.childElementCount; i++) {
            //Andiamo a ritroso
            let counter = iconsContainer.childElementCount - i - 1;

            //Se la prima icona iterata (quindi la i-esima partendo dall'ultima) non e' visibile, il rightPaddle diventa d-none e si passa all'icona successiva
            if (window.getComputedStyle(iconsContainer.children[counter]).display === "none") {
                //Se arriviamo all'ultima icona iterata (che sarebbe la prima da sx a dx) e anch'essa non e' visibile
                //il rightPaddle diventa invisibile
                if (i === iconsContainer.childElementCount - 1) {
                    result.rightPaddleEnabled = false;
                }
                continue;
            } else {
                //Invece, se l'icona iterata (quindi la i-esima partendo dall'ultima) e' visibile
                let iconRightSide = iconsContainer.children[counter].getBoundingClientRect().right;

                //Se il suo lato destro e' maggiore del lato destro dell'iconsContainer, il rightPaddle diventa visibile
                if (iconRightSide > iconsContainerRightSide) {
                    result.rightPaddleEnabled = true;
                    break;
                } else {
                    //Altrimenti il rightPaddle diventa invisibile e si interrompe il ciclo
                    result.rightPaddleEnabled = false;
                    break;
                }
            }
        }
    } else {
        result.leftPaddleEnabled = false;
        result.rightPaddleEnabled = false;
    }

    //dropdown
    //Per il dropdownButton ci basta che o uno solo tra leftPaddle e rightPaddle siano visibili per poterlo rendere visibile
    if (result.leftPaddleEnabled || result.rightPaddleEnabled) {
        result.dropdownEnabled = true;
    } else {
        result.dropdownEnabled = false;
    }

    return result;
}

export const MAXIMUM_NUMBER_OF_ROWS = 8;
export function calculateNumberOfRows(iconsContainer,maxNumberOfRows) {
    let numberOfRows = 1;
    
    if (window.getComputedStyle(iconsContainer).width === "auto" || window.getComputedStyle(iconsContainer).width === "100%") {
        numberOfRows = maxNumberOfRows || MAXIMUM_NUMBER_OF_ROWS
        
        Array.from(iconsContainer).forEach(icon => {
            icon.removeAttribute("style");
        });
        return numberOfRows;
    }
    
    //v1
    let tempWidth = 0;
    const iconsContainerParentRect = iconsContainer.parentElement.getBoundingClientRect();
    Array.from(iconsContainer.children).forEach(icon => {
        const iconComputedStyle = window.getComputedStyle(icon);
        if (iconComputedStyle.display !== "none") {
            icon.removeAttribute("style");
            tempWidth += icon.getBoundingClientRect().width;
            tempWidth += parseFloat(iconComputedStyle.marginLeft);
            tempWidth += parseFloat(iconComputedStyle.marginRight);

            if (tempWidth > iconsContainerParentRect.width) {
                let oneRowOfIconsWidthMiniusLastIconMarginRight = tempWidth - parseFloat(iconComputedStyle.marginRight);
                if (oneRowOfIconsWidthMiniusLastIconMarginRight <= iconsContainerParentRect.width) {
                    tempWidth -= parseFloat(iconComputedStyle.marginRight);
                    icon.setAttribute("style", "margin-right: 0px !important");
                    return
                } else {
                    numberOfRows += 1
                    tempWidth = 0;
                    tempWidth += icon.getBoundingClientRect().width;
                    tempWidth += parseFloat(iconComputedStyle.marginLeft);
                    tempWidth += parseFloat(iconComputedStyle.marginRight);
                }
            }
        }
    });

    return numberOfRows;
}
